import axios from "axios";

export const EP = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/employee-portal`, withCredentials: true });

export const fmtDate = (d) => {
  if (!d) return "—";
  const t = new Date(d);
  return Number.isNaN(t.getTime()) ? String(d).slice(0, 10) : t.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const TONE = {
  good: "bg-emerald-50 text-emerald-700 border-emerald-200",
  warn: "bg-amber-50 text-amber-700 border-amber-200",
  bad: "bg-rose-50 text-rose-700 border-rose-200",
  info: "bg-sky-50 text-sky-700 border-sky-200",
  neutral: "bg-slate-100 text-slate-600 border-slate-200",
};

const GOOD = ["DELIVERED", "VERIFIED", "CONFIRMED", "COMPLETED", "RESOLVED", "CLOSED", "IN_USE", "DEPLOYED", "ASSIGNED", "ACTIVE", "RECEIVED", "PICKED_UP"];
const WARN = ["PENDING", "CHANGE_REQUESTED", "APPROVAL_PENDING", "SUBMITTED", "SCHEDULED", "NEW", "OPEN", "RECOVERY_PENDING", "IN_PROGRESS", "IN_REPAIR"];
const INFO = ["IN_TRANSIT", "DISPATCHED", "SHIPPED", "OUT_FOR_DELIVERY"];

export function Pill({ value, testid }) {
  const v = String(value || "—").toUpperCase();
  const tone = GOOD.includes(v) ? "good" : INFO.includes(v) ? "info" : WARN.includes(v) ? "warn" : v.includes("FAIL") || v.includes("CANCEL") || v.includes("OVERDUE") || v.includes("BREACH") ? "bad" : "neutral";
  return <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold tracking-wide whitespace-nowrap ${TONE[tone]}`} data-testid={testid}>{v.replace(/_/g, " ")}</span>;
}

export function Section({ title, icon: Icon, children, testid, action }) {
  return (
    <section className="rounded-2xl bg-white border border-slate-200 shadow-sm overflow-hidden" data-testid={testid}>
      <header className="flex items-center gap-2 px-4 py-3 border-b border-slate-100">
        {Icon && <Icon className="h-4 w-4 text-[#0B1730]" />}
        <h2 className="text-[13px] font-bold tracking-[0.12em] uppercase text-[#0B1730]">{title}</h2>
        {action && <div className="ml-auto">{action}</div>}
      </header>
      <div className="p-4 space-y-3">{children}</div>
    </section>
  );
}

export function KV({ label, value, mono }) {
  return (
    <div className="flex justify-between gap-3 text-[13px] py-1 border-b border-dashed border-slate-100 last:border-0">
      <span className="text-slate-500 shrink-0">{label}</span>
      <span className={`text-right text-slate-900 font-medium break-words ${mono ? "font-mono text-[12px]" : ""}`}>{value || "—"}</span>
    </div>
  );
}

export function Btn({ children, onClick, tone = "primary", disabled, testid, href }) {
  const cls = tone === "primary" ? "bg-[#0B1730] text-white hover:bg-[#13264d]" : tone === "danger" ? "bg-rose-600 text-white hover:bg-rose-700" : "bg-white text-[#0B1730] border border-slate-300 hover:bg-slate-50";
  const base = `inline-flex items-center justify-center gap-1.5 h-11 px-4 rounded-xl text-[14px] font-semibold transition-colors disabled:opacity-50 w-full sm:w-auto ${cls}`;
  if (href) return <a href={href} target="_blank" rel="noreferrer" className={base} data-testid={testid}>{children}</a>;
  return <button onClick={onClick} disabled={disabled} className={base} data-testid={testid}>{children}</button>;
}

export function Empty({ text }) {
  return <p className="text-[13px] text-slate-400 text-center py-3">{text}</p>;
}

export const inputCls = "w-full h-11 rounded-xl border border-slate-300 px-3 text-[15px] bg-white focus:outline-none focus:ring-2 focus:ring-[#0B1730]/30";
export const textareaCls = "w-full min-h-[88px] rounded-xl border border-slate-300 px-3 py-2 text-[15px] bg-white focus:outline-none focus:ring-2 focus:ring-[#0B1730]/30";
